import React from 'react';
import { Button } from 'primereact/button';

/**
 * FinanceView Component
 * 
 * Renders the finance section with left menu panel showing:
 * - Receipt Entry
 * - Fee Details
 * - View Transactions
 * - Fee Management
 * - View Cheque Payments
 * - Transport Fee Management
 * - Cheque Bounce Charges
 * - Post Dated Cheque Payments
 * - Advance Payments
 * - Edit Fee Amount
 * - Student Deposits / Transactions
 * - Loan Payments
 * 
 * And content area on the right displaying the selected finance view
 */
export const FinanceView = ({ 
    activeSubMenu,
    financeMinimized,
    onMenuItemClick,
    onToggleMinimize,
    onFeeDetailsClick,
    renderFinanceView
}) => {
    return (
        <div className="finance-section-container">
            <div className={`finance-layout ${financeMinimized ? 'minimized' : ''}`}>
                {/* Left Finance Menu Panel */}
                <div className="finance-left-menu">
                    <div className="finance-menu-header">
                        <h3>Finance</h3>
                        <Button
                            icon={financeMinimized ? "pi pi-chevron-right" : "pi pi-chevron-left"}
                            className="p-button-text p-button-rounded toggle-btn"
                            onClick={onToggleMinimize}
                            tooltip={financeMinimized ? "Expand Menu" : "Collapse Menu"}
                            tooltipOptions={{ position: 'right' }}
                        />
                    </div>
                    <div className="finance-menu-items">
                        {/* <div 
                            className={`finance-menu-item ${activeSubMenu === 'receiptEntry' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showFinanceView: true, 
                                activeFinanceView: 'receiptEntry', 
                                activeSubMenu: 'receiptEntry' 
                            })}
                        >
                            <i className="pi pi-receipt"></i>
                            <span>Receipt Entry</span>
                        </div> */}
                        <div 
                            className={`finance-menu-item ${activeSubMenu === 'feeDetails' ? 'active' : ''}`}
                            onClick={onFeeDetailsClick}
                        >
                            <i className="pi pi-money-bill"></i>
                            <span>Fee Details</span>
                        </div>
                        <div 
                            className={`finance-menu-item ${activeSubMenu === 'viewTransactions' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showFinanceView: true, 
                                activeFinanceView: 'viewTransactions', 
                                activeSubMenu: 'viewTransactions' 
                            })}
                        >
                            <i className="pi pi-list"></i>
                            <span>View Transactions</span>
                        </div>
                        {/* <div 
                            className={`finance-menu-item ${activeSubMenu === 'feeManagement' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showFinanceView: true, 
                                activeFinanceView: 'feeManagement', 
                                activeSubMenu: 'feeManagement' 
                            })}
                        >
                            <i className="pi pi-cog"></i>
                            <span>Fee Management</span>
                        </div> */}
                        <div 
                            className={`finance-menu-item ${activeSubMenu === 'viewChequePayments' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showFinanceView: true, 
                                activeFinanceView: 'viewChequePayments', 
                                activeSubMenu: 'viewChequePayments' 
                            })}
                        >
                            <i className="pi pi-credit-card"></i>
                            <span>View Cheque Payments</span>
                        </div>
                        <div 
                            className={`finance-menu-item ${activeSubMenu === 'transportFeeManagement' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showFinanceView: true, 
                                activeFinanceView: 'transportFeeManagement', 
                                activeSubMenu: 'transportFeeManagement' 
                            })}
                        >
                            <i className="fa fa-bus"></i>
                            <span>Transport Fee Management</span>
                        </div>
                        <div 
                            className={`finance-menu-item ${activeSubMenu === 'chequeBounceCharges' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showFinanceView: true, 
                                activeFinanceView: 'chequeBounceCharges', 
                                activeSubMenu: 'chequeBounceCharges' 
                            })}
                        >
                            <i className="pi pi-exclamation-triangle"></i>
                            <span>Cheque Bounce Charges</span>
                        </div>
                        <div 
                            className={`finance-menu-item ${activeSubMenu === 'postDatedChequePayments' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showFinanceView: true, 
                                activeFinanceView: 'postDatedChequePayments', 
                                activeSubMenu: 'postDatedChequePayments' 
                            })}
                        >
                            <i className="pi pi-calendar-plus"></i>
                            <span>Post Dated Cheque Payments</span>
                        </div>
                        <div 
                            className={`finance-menu-item ${activeSubMenu === 'advancePayments' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showFinanceView: true, 
                                activeFinanceView: 'advancePayments', 
                                activeSubMenu: 'advancePayments' 
                            })}
                        >
                            <i className="pi pi-forward"></i>
                            <span>Advance Payments</span>
                        </div>
                        {/* <div 
                            className={`finance-menu-item ${activeSubMenu === 'editFeeAmount' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showFinanceView: true, 
                                activeFinanceView: 'editFeeAmount', 
                                activeSubMenu: 'editFeeAmount' 
                            })}
                        >
                            <i className="pi pi-pencil"></i>
                            <span>Edit Fee Amount</span>
                        </div> */}
                        {/* <div 
                            className={`finance-menu-item ${activeSubMenu === 'studentDepositsTransactions' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showFinanceView: true, 
                                activeFinanceView: 'studentDepositsTransactions', 
                                activeSubMenu: 'studentDepositsTransactions' 
                            })}
                        >
                            <i className="pi pi-database"></i>
                            <span>Student Deposits / Transactions</span>
                        </div> */}
                        {/* <div 
                            className={`finance-menu-item ${activeSubMenu === 'loanPayments' ? 'active' : ''}`}
                            onClick={() => onMenuItemClick({ 
                                showFinanceView: true, 
                                activeFinanceView: 'loanPayments', 
                                activeSubMenu: 'loanPayments' 
                            })}
                        >
                            <i className="pi pi-wallet"></i>
                            <span>Loan Payments</span>
                        </div> */}
                    </div>
                </div>

                {/* Right Finance Content Area */}
                <div className="finance-content-area">
                    {renderFinanceView()}
                </div>
            </div>
        </div>
    );
};

export default FinanceView;
